import { CouponManager, genfunction } from "helpers";

const { DefaultCostRateID } = window['runConfig'];

export default {

    ApplyCouponsToEvents(events, coupons, TourProducts, couponAlreadyApply, couponCode) {

        let index = 0;
        coupons.forEach(coupon => {

            let applyDisProdID = coupon.TourProducts && coupon.TourProducts.length > 0 ? coupon.TourProducts[0].ApplyDiscountToTourProductID : 0;

            let tourProd = TourProducts.find(x => x.TourProductID == applyDisProdID);

            events.filter(e => e.PaymentOption ? e.PaymentOption === "FullPay" || e.PaymentOption === "MinimumPay" : true).forEach(event => {

                if (event.CouponItems.length < 1) {
                    event.CouponItems = [];
                }
                else {
                    if (coupon.RequireUniqueCouponCode) {

                        let sum = 0;
                        event.CouponItems.forEach(obj => {
                            if (obj.isUniqueCoupon)
                                sum += obj.Quantity;
                        })

                        coupon.MaxProductsLimit += sum;

                    }

                    event.CouponItems = event.CouponItems.filter(x => x.CouponID != coupon.CouponID);
                }

                let eventProds = this.SortProductsPriceWise(event.TourProducts);

                eventProds.forEach(product => {

                    var prod = coupon.TourProducts.find(x => x.TourProductID == product.TourProductID);

                    if (prod) {

                        let couponObj = {

                            CouponID: coupon.CouponID,
                            CouponCode: coupon.CouponCode,
                            ApplyDiscountProductID: tourProd.PriceMatrix ? tourProd.PriceMatrix[0].ProductID : 0,
                            ApplyDiscountTourProductID: tourProd.TourProductID,
                            ApplyDiscountTourProductName: tourProd.TourProductName,
                            TourEventID: event.TourEventID,
                            TourProductID: product.TourProductID,
                            TourProductName: product.TourProductName,
                            UniqueCouponCode: coupon.RequireUniqueCouponCode ? couponCode : coupon.CouponCode,
                            isUniqueCoupon: coupon.RequireUniqueCouponCode ? true : false,
                            Quantity: product.Quantity,
                            CouponHoldRef: null,
                            ProdQuantity: product.Quantity
                        }

                        couponObj.isPercentage = prod.hasOwnProperty("PercentageDiscount") ? true : false;
                        couponObj.Discount = prod.hasOwnProperty("PercentageDiscount") ? genfunction.IsNullOrUndefineReturnZero(prod.PercentageDiscount) : genfunction.IsNullOrUndefineReturnZero(prod.DollarDiscount);


                        let ProductAmount = genfunction.IsNotFullPay(event.PaymentOption) ? product.ProductSelectedAmount : product.ProductAmount;
                        let ProductTaxAmount = genfunction.IsNotFullPay(event.PaymentOption) ? product.ProductSelectedTaxAmount : product.ProductTaxAmount;

                        if (coupon.RequireUniqueCouponCode) {

                            if (coupon.MaxProductsLimit <= 0) {
                                return;
                            }

                            couponObj.CouponHoldRef = coupon.CouponHoldRef;
                            couponObj.Quantity = product.Quantity <= coupon.MaxProductsLimit ? product.Quantity : coupon.MaxProductsLimit;
                            couponObj.TicketAmount = couponObj.isPercentage ? Math.round(CouponManager.CalculateTicketOddQuantities(ProductAmount / product.Quantity, couponObj.Quantity, couponObj.Discount, product, event.PaymentOption) * 100) / 100 : Math.round(CouponManager.CalculateDollarTicketPrice(ProductAmount, prod.DollarDiscount, couponObj.Quantity, product, event.PaymentOption) * 100) / 100;
                            couponObj.TicketTax = couponObj.isPercentage ? Math.round(CouponManager.CalculateTaxOddQuantities(ProductTaxAmount / product.Quantity, couponObj.Quantity, couponObj.Discount, product, event.PaymentOption) * 100) / 100 : Math.round(CouponManager.CalculateDollarTicketTax(couponObj.TicketAmount, prod.DollarDiscount * couponObj.Quantity, couponObj.Quantity, product, event.PaymentOption) * 100) / 100;


                            coupon.MaxProductsLimit -= couponObj.Quantity;
                        }
                        else {
                            couponObj.TicketAmount = couponObj.isPercentage ? Math.round(ProductAmount * (couponObj.Discount / 100) * 100) / 100 : Math.round(CouponManager.CalculateDollarTicketPrice(ProductAmount, genfunction.IsNullOrUndefineReturnZero(prod.DollarDiscount), product.Quantity, product, event.PaymentOption) * 100) / 100;
                            couponObj.TicketTax = couponObj.isPercentage ? Math.round(ProductTaxAmount * (couponObj.Discount / 100) * 100) / 100 : Math.round(CouponManager.CalculateDollarTicketTax(couponObj.TicketAmount, genfunction.IsNullOrUndefineReturnZero(prod.DollarDiscount) * product.Quantity, couponObj.Quantity, product, event.PaymentOption) * 100) / 100;
                        }


                        couponObj.TotalAmount = couponObj.TicketAmount + couponObj.TicketTax;
                        this.OnePennyDifference(product, couponObj, event.PaymentOption);

                        let itemIndex = event.CouponItems.findIndex(x => x.TourProductID == product.TourProductID &&
                            (genfunction.IsNotFullPay(event.PaymentOption) ? x.TotalSelectedAmount : x.TotalAmount) < couponObj.TotalAmount);

                        if (itemIndex >= 0) {
                            event.CouponItems[itemIndex] = couponObj;

                        }

                        else {

                            if (event.CouponItems.find(x => x.TourProductID == product.TourProductID &&
                                (genfunction.IsNotFullPay(event.PaymentOption) ? x.TotalSelectedAmount : x.TotalAmount) >= couponObj.TotalAmount)) {
                                couponAlreadyApply = true;
                                return;
                            }

                            event.CouponItems.push(couponObj);
                        }

                    }
                })
            })
            index++;
        })

        return couponAlreadyApply;
    },

    RemoveUniqueCouponNotApplied(events, couponCode) {
        let remove = 0;
        events.map(obj => {

            if (obj.CouponItems && obj.CouponItems.filter(x => x.isUniqueCoupon && x.CouponHoldRef == couponCode).length > 0) {
                remove += 1;
            }
        });

        return remove > 0 ? false : true;
    },

    CalcuateCouponDiscounts(products) {
        let totalDiscount = 0;

        products.map(product => (

            product.CouponItems.map(e =>

                totalDiscount += e.TotalAmount
            )
        ));

        return products.map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0) - totalDiscount;
    },

    CalculateDollarTicketPrice(ExTaxAmount, DollarPercent, ApplyQty, Product, PaymentOption) {

        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded) {
            if (DollarPercent * ApplyQty > (genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedTotalAmount : Product.ProductTotalAmount)) {
                return genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedAmount : Product.ProductAmount;
            }

            if (DollarPercent > (ExTaxAmount / Product.Quantity) && ApplyQty != Product.Quantity) {
                return (ExTaxAmount / Product.Quantity) * ApplyQty;
            }

            return DollarPercent * ApplyQty / (1 + (Product.PriceMatrix[0].Taxes[0].TaxPercentage / 100));
        }
        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded == false) {

            if (DollarPercent * ApplyQty > ExTaxAmount) {
                return ExTaxAmount;
            }

            if (DollarPercent > Product.IndividualPrice && ApplyQty != Product.Quantity) {
                return Product.IndividualPrice * ApplyQty;
            }

            return DollarPercent * ApplyQty;
        }

        return 0;
    },

    CalculateDollarTicketTax(ExTaxAmount, DollarPercent, ApplyQty, Product, PaymentOption) {

        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded) {
            if (DollarPercent > (genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedAmount : Product.ProductAmount) && Product.Quantity == 1) {
                return (genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedTaxAmount : Product.ProductTaxAmount);
            }

            if (DollarPercent > ((genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedAmount : Product.ProductAmount)
                / Product.Quantity) && Product.Quantity != ApplyQty) {
                return (Product.ProductTaxAmount / Product.Quantity) * ApplyQty;
            }

            return DollarPercent - ExTaxAmount;
        }

        if (Product.PriceMatrix[0].Taxes[0].TaxIncluded == false) {
            if (DollarPercent > ExTaxAmount) {
                return (ExTaxAmount * (Product.PriceMatrix[0].Taxes[0].TaxPercentage / 100));
            }

            return (DollarPercent * (Product.PriceMatrix[0].Taxes[0].TaxPercentage / 100));
        }

        return 0;
    },

    UniqueCouponPostRequest(couponObj, events, bookingCoupons) {

        let holdReq = 0;
        let eventProdsTotal = 0;
        let error = '';

        if (events && events.length > 0) {
            events.forEach(event => {

                event.TourProducts.forEach((product) => {
                    if (product.Quantity > 0 && couponObj.TourProducts.filter(x => x.TourProductID == product.Quantity)) {
                        eventProdsTotal += product.Quantity;
                    }
                });
            });
        }

        if (couponObj.MaxProductsPerPurchase < eventProdsTotal) {
            holdReq = couponObj.MaxProductsPerPurchase;
        }
        else {
            holdReq = eventProdsTotal;
        }

        couponObj.TimesUsed += holdReq;

        if (couponObj.TimesUsed > couponObj.MaxTransactionsPerCoupon) {
            error = 'This Coupon is used maximum number of times.';
        }

        //Create Unique Coupon Hold Request
        let UniqueCouponHolds = [];
        let UniqueCoupon = {};
        UniqueCoupon.UniqueCouponCode = couponObj.UniqueCouponCode;
        UniqueCoupon.HoldsRequested = holdReq;
        UniqueCouponHolds.push(UniqueCoupon);

        return { 'UniqueCoupon': UniqueCouponHolds, 'Error': error }
    },

    CalculateTicketOddQuantities(ExProductsTotal, ProdQuantities, Discount, Product, PaymentOption) {

        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded) {
            if (Discount == 100) {
                return ((genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedAmount : Product.ProductAmount) / Product.Quantity) * ProdQuantities;
            }

            return (ExProductsTotal * ProdQuantities) * (Discount / 100);
        }

        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded == false) {
            if (Discount == 100) {
                return Math.round(ExProductsTotal * ProdQuantities * 100) / 100;
            }
            else {
                return Math.round((ExProductsTotal * ProdQuantities) * (Discount / 100) * 100) / 100
            }
        }
    },

    CalculateTaxOddQuantities(ExTaxTotal, ProdQuantities, Discount, Product, PaymentOption) {

        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded) {
            if (Discount == 100) {
                return ((genfunction.IsNotFullPay(PaymentOption) ? Product.ProductSelectedTaxAmount : Product.ProductTaxAmount) / Product.Quantity) * ProdQuantities;
            }


            return (ExTaxTotal * ProdQuantities) * (Discount / 100);
        }

        if (Product.PriceMatrix && Product.PriceMatrix[0].Taxes[0].TaxIncluded == false) {
            if (Discount == 100) {
                return Math.round(ExTaxTotal * ProdQuantities * 100) / 100;
            }
            else {
                return Math.round((ExTaxTotal * ProdQuantities) * (Discount / 100) * 100) / 100;
            }
        }

    },

    RemoveProductItem(newevents, eventID, productID) {
        let noproducteventid = 0;
        newevents = newevents.map(obj => {
            if (obj.TourEventID === eventID) {
                obj.CouponItems = obj.CouponItems.filter(p => p.TourProductID !== productID);
                if (obj.CouponItems.length === 0) {
                    noproducteventid = obj.TourEventID;
                }
            }
            return obj;
        });


        return newevents;
    },

    RemoveUnusedCoupon(newcouponTours, newevents) {
        newcouponTours = newcouponTours.map(c => {
            c.Accessable = false;
            newevents.map(e => {

                if (e.CouponItems.find(x => x.CouponID == c.CouponID) !== undefined) {
                    c.Accessable = true;
                }
            });

            return c;
        });

        newcouponTours = newcouponTours.filter(x => x.Accessable).map(x => {
            return x;
        });

        return newcouponTours;
    },

    UpdateMaxProductLimit(newcouponTours, newevents, eventID, prodID) {
        let prodCoupon = null;
        let event = newevents.find(x => x.TourEventID === eventID);
        if (event) {
            prodCoupon = event.CouponItems.find(x => x.TourProductID == prodID);
        }

        if (prodCoupon && prodCoupon.isUniqueCoupon) {
            newcouponTours = newcouponTours.map(c => {

                if (c.CouponID === prodCoupon.CouponID) {
                    c.MaxProductsLimit += prodCoupon.Quantity;
                }
                return c;
            });
        }

        return newcouponTours;
    },

    SortProductsPriceWise(eventProducts) {
        let eventProds = eventProducts;
        return eventProds.sort((a, b) => b.IndividualPrice - a.IndividualPrice);
    },

    OnePennyDifference(product, coupon, PaymentOption) {
        if (product.PriceMatrix && product.PriceMatrix[0].Taxes[0].TaxIncluded && coupon.Quantity == product.Quantity) {
            if (Math.round((coupon.TotalAmount - (

                (genfunction.IsNotFullPay(PaymentOption) ? product.ProductSelectedTotalAmount : product.ProductTotalAmount) * (coupon.Discount / 100))) * 100) / 100 === 0.01) {
                coupon.TotalAmount -= 0.01;
                coupon.TicketTax -= 0.01;

            }
        }
    }
}